import { z } from 'zod'

// 全 API endpoint のエラーレスポンス共通形式
export const ErrorResponseSchema = z.object({
  error: z.string(),
  details: z.unknown().optional(),
  request_id: z.string().optional(),
})
export type ErrorResponse = z.infer<typeof ErrorResponseSchema>

export const ERROR_CODES = {
  INVALID_REQUEST: 'invalid_request',
  UNAUTHORIZED: 'unauthorized',
  FORBIDDEN: 'forbidden',
  NOT_FOUND: 'not_found',
  CONFLICT: 'conflict',
  INTERNAL: 'internal',
} as const
